import React, { useEffect, useState } from 'react'
import Header from '../adminComponents/header/Header'
import { Box, Button, FormControl, FormControlLabel, Grid, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';
import { useFormik } from 'formik';
import ImageUploadField from '../adminComponents/CommonTextField/ImageUploadField';
import CustomTextField from '../adminComponents/CommonTextField/CustomTextField';
import * as Yup from 'yup';
import SuccessModal from '../adminComponents/successModal/SuccessModal';
import { useNavigate, useParams } from 'react-router-dom';
import { addOurCategoriesItems, udpateOurCategoriesItems } from '../services/Products';
import { getOurCategories, getItemsByID } from '../services/OurCategories';
import { useMediaQueries } from '../usecontext/UseProvider';

// const validationSchema = Yup.object({
//     name: Yup.string().required('The product name field is required.'),
//     description: Yup.string().required('The description field is required.'),
//     tags: Yup.string().required('The tag field is required.'),
//     height: Yup.string().required('The height field is required.'),
//     width: Yup.string().required('The width field is required.'),
//     length: Yup.string().required('The length field is required.'),
//     material: Yup.string().required('The material field is required.'),
//     warranty: Yup.string().required('The warranty field is required.'),
//     hangingSet: Yup.string().required('The hanging set field is required.'),
//     cushion: Yup.string().required('The cushion field is required.'),
//     maintenance: Yup.string().required('The maintenance field is required.'),
//     customizationAvailable: Yup.string().required('The customization available field is required.'),
//     additionalInformation: Yup.string().required('The additional information field is required.'),
//     images: Yup.array()
//         .min(1, 'You must upload at least 1 image')
//         .required('The image field is required.'),
//     isDisplaingInSomethingUnique: Yup.string().required('Please select an option'),
// });

const validationSchema = Yup.object({
    name: Yup.string(),
    description: Yup.string(),
    tags: Yup.string(),
    height: Yup.string(),
    width: Yup.string(),
    length: Yup.string(),
    material: Yup.string(),
    warranty: Yup.string(),
    hangingSet: Yup.string(),
    cushion: Yup.string(),
    maintenance: Yup.string(),
    customizationAvailable: Yup.string(),
    additionalInformation: Yup.string(),
    images: Yup.array(),
    isDisplaingInSomethingUnique: Yup.string(),
});

const selectStyles = {
    backgroundColor: "#f5f5f5",
    border: 'none',
    '&:hover': {
        border: 'unset',
        boxShadow: 'none',
    },
    '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #e5e5e5',
    },
    minWidth: '150px',
};

const menuPropsStyles = {
    PaperProps: {
        sx: {
            fontSize: '14px',
            py: 0,
            '& .MuiMenuItem-root': {
                '&.Mui-selected:hover': {
                    backgroundColor: '#0A2357',
                    color: '#fff',
                },
                '&.Mui-selected': {
                    backgroundColor: '#0A2357',
                    color: '#fff',
                },
            },
            '& .MuiList-root': {
                py: 0,
            },
        },
    },
};
const ProductFormPage = () => {
    const userdata = JSON.parse(localStorage.getItem('admin'));
    const userId = userdata?._id;
    const navigate = useNavigate()
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [error, setError] = useState('');
    const [categoryData, setCategoryData] = useState([]);
    const [isDisplaingInSomethingUnique, setIsDisplaingInSomethingUnique] = useState("yes");
    const { id } = useParams();
    const [ourCategoriesData, setOurCategoriesData] = useState([]);
    const {setLoading} = useMediaQueries()
    const [isEditing, setIsEditing] = useState(false);

    const getOurCategoriesData = async () => {
        try {
            setLoading(true);
            const response = await getOurCategories();
            setOurCategoriesData(response?.categoryData);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    const getProductData = async () => {
        if (id) {
            try {
                setLoading(true);
                const response = await getItemsByID(id);
                const productData = response?.categoryItemData;
                
                // Set form values with fetched data
                formik.setValues({
                    name: productData?.name || '',
                    description: productData?.description || '',
                    tags: productData?.tags?.join(', ') || '',
                    height: productData?.height || '',
                    width: productData?.width || '',
                    length: productData?.length || '',
                    material: productData?.material || '',
                    warranty: productData?.warranty || '',
                    hangingSet: productData?.hangingSet || '',
                    cushion: productData?.cushion || '',
                    maintenance: productData?.maintenance?.join(', ') || '',
                    customizationAvailable: productData?.customizationAvailable || '',
                    additionalInformation: productData?.additionalInformation?.join(', ') || '',
                    images: productData?.images || null,
                    isDisplaingInSomethingUnique: productData?.isDisplaingInSomethingUnique?.toString() || 'false',
                    createdBy: productData?.createdBy?._id || ''
                });
                
                setIsEditing(true);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        getOurCategoriesData();
        getProductData();
    }, [id]);

    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
            tags: '',
            height: '',
            width: '',
            length: '',
            material: '',
            warranty: '',
            hangingSet: '',
            cushion: '',
            maintenance: '',
            customizationAvailable: '',
            additionalInformation: '',
            images: null,
            isDisplaingInSomethingUnique: 'false',
            createdBy: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const formData = new FormData();

                // Append all form fields
                Object.keys(values).forEach(key => {
                    if (key === 'images') {
                        // Handle multiple images
                        if (values.images) {
                            values.images.forEach((image, index) => {
                                formData.append('images', image);
                            });
                        }
                    } else {
                        formData.append(key, values[key]);
                    }
                });
                setLoading(true);
                let result;
                if (isEditing) {
                    // Update existing product
                    result = await udpateOurCategoriesItems(formData, id);
                    navigate('/admin/manage-store/products');
                } else {
                    // Add new product
                    result = await addOurCategoriesItems(formData);
                    navigate('/admin/manage-store/products');
                }
                setLoading(false);
                if (result.error) {
                    setError(result.error);

                } else {
                    setSuccessModalOpen(true);
                    formik.resetForm();
                }
            } catch (error) {
                setError('Failed to save product. Please try again.');
            }
        },
    });

    const handleClose = () => {
        formik.resetForm();
    };

    return (
        <>
            <Header title={isEditing ? "Edit Product" : "Add Product"} />
            <Box sx={{ pt: 3 }}>
                <Paper sx={{ p: { sm: 5, xs: 3 } }}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <ImageUploadField
                                    label="Images"
                                    name="images"
                                    formik={formik}
                                    data={categoryData}
                                    imageHeight='70px'
                                    imageWidth='70px'
                                    multiple
                                />
                                <CustomTextField
                                    label="Product Name"
                                    name="name"
                                    formik={formik}
                                    placeholder="Product Name"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <Typography variant="body1" sx={{ color: '#ADADAD', mt: 2 }}>Category</Typography>
                                <FormControl fullWidth size="small" sx={{ mt: 2 }} error={formik.touched.createdBy && Boolean(formik.errors.createdBy)}>
                                    <Select
                                        labelId="category-label"
                                        id="createdBy"
                                        name="createdBy"
                                        value={formik.values.createdBy}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        MenuProps={menuPropsStyles}
                                        sx={selectStyles}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>
                                            Select Category
                                        </MenuItem>
                                        {ourCategoriesData.map((category) => (
                                            <MenuItem key={category._id} value={category._id}>
                                                {category.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.category && formik.errors.category && (
                                        <Typography color="error" variant='body2' mt={1}>
                                            {formik.errors.category}
                                        </Typography>
                                    )}
                                </FormControl>

                                {/* <Typography variant="body1" sx={{ color: '#ADADAD', mt: 2 }}>Tags</Typography>
                                <FormControl fullWidth size="small" sx={{ mt: 2 }} error={formik.touched.tags && Boolean(formik.errors.tags)}>
                                    <Select
                                        labelId="tags-label"
                                        id="tags"
                                        name="tags"
                                        value={formik.values.tags}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        MenuProps={menuPropsStyles}
                                        sx={selectStyles}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>
                                            Select Tag
                                        </MenuItem>
                                        <MenuItem value="Tag1">Tag1</MenuItem>
                                        <MenuItem value="Tag2">Tag2</MenuItem>
                                        <MenuItem value="Tag3">Tag3</MenuItem>
                                    </Select>
                                    {formik.touched.tags && formik.errors.tags && (
                                        <Typography color="error" variant='body2' mt={1}>
                                            {formik.errors.tags}
                                        </Typography>
                                    )}
                                </FormControl> */}

                                <CustomTextField
                                    label="Description"
                                    name="description"
                                    formik={formik}
                                    placeholder="Enter Description"
                                    minRows={4}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Tags"
                                    name="tags"
                                    formik={formik}
                                    placeholder="Enter Tags (comma separated)"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={4}>
                                        <CustomTextField
                                            label="Length"
                                            name="length"
                                            formik={formik}
                                            placeholder="Enter Length"
                                            size='small'
                                            sx={{ mt: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <CustomTextField
                                            label="Width"
                                            name="width"
                                            formik={formik}
                                            placeholder="Enter Width"
                                            size='small'
                                            sx={{ mt: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <CustomTextField
                                            label="Height"
                                            name="height"
                                            formik={formik}
                                            placeholder="Enter Height"
                                            size='small'
                                            sx={{ mt: 2 }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    label="Material"
                                    name="material"
                                    formik={formik}
                                    placeholder="Enter Material"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Warranty"
                                    name="warranty"
                                    formik={formik}
                                    placeholder="Enter Warranty Details"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Hanging Set"
                                    name="hangingSet"
                                    formik={formik}
                                    placeholder="Enter Hanging Set Details"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Cushion"
                                    name="cushion"
                                    formik={formik}
                                    placeholder="Enter Cushion Details"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Maintenance"
                                    name="maintenance"
                                    formik={formik}
                                    placeholder="Enter Maintenance Instructions"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Customization Available"
                                    name="customizationAvailable"
                                    formik={formik}
                                    placeholder="Enter Customization Options"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Additional Information"
                                    name="additionalInformation"
                                    formik={formik}
                                    placeholder="Enter Additional Information"
                                    size='small'
                                    sx={{ mt: 2 }}
                                    multiline={true}
                                />
                                <Typography variant="body1" sx={{ color: '#ADADAD', mt: 2 }}>Display in Something Unique</Typography>
                                <RadioGroup
                                    aria-label="unique-mode"
                                    name="isDisplaingInSomethingUnique"
                                    value={formik.values.isDisplaingInSomethingUnique}
                                    onChange={formik.handleChange}
                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={
                                            <Radio
                                                sx={{
                                                    color: "#01A0E2",
                                                    "&.Mui-checked": {
                                                        color: "#01A0E2",
                                                    },
                                                }}
                                            />
                                        }
                                        label="Yes"
                                        sx={{ color: "black" }}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={
                                            <Radio
                                                sx={{
                                                    color: "#01A0E2",
                                                    "&.Mui-checked": {
                                                        color: "#01A0E2",
                                                    },
                                                }}
                                            />
                                        }
                                        label="No"
                                        sx={{ color: "black" }}
                                    />
                                </RadioGroup>
                            </Grid>
                        </Grid>

                        {error && (
                            <Typography color="error" variant='caption'>{error}</Typography>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                            >
                                {isEditing ? 'Update' : 'Submit'}
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Box>
            <SuccessModal
                open={successModalOpen}
                onClose={() => setSuccessModalOpen(false)}
                message={isEditing ? "Product updated successfully" : "Product added successfully"}
            />
        </>
    )
}

export default ProductFormPage